import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChartPie,
    faCommentsDollar,
    faGlobe,
    faLightbulb,
    faPeopleCarryBox,
    faUsersGear
} from "@fortawesome/free-solid-svg-icons";
import homeBg from "../images/confirm.png";
import useInView from "../lib/useInView";
import MarketMarquee from "../components/MarketMarque";
import Hero from "../components/HeroSection";
import SavingsShowcase from "../components/SavingsShowcase";
import Explore from "../components/Explore";
import Features from "../components/Features";



const HomePage = () => {
    const navigate = useNavigate();


    // to handle animations using the custom 'in view' hook
    const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box2Ref, box2InView] = useInView({ threshold: 0.7 });
    const [box3Ref, box3InView] = useInView({ threshold: 0.7 });
    const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
    const [box5Ref, box5InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });





    return (
        <>
            <div id="hero-section">
                {/* New Hero Section */}
                <Hero />

                <MarketMarquee />
            </div>

            <section className="hero-feature-section">
                {/* Check hero section css for styles */}
                <div className="feature-box">
                    <h2>Offshore Banking Excellence</h2>
                    <p>
                        Discover secure, multi-currency offshore accounts designed for global
                        flexibility and asset protection. Enjoy discreet private banking,
                        seamless international access, and personalized financial management
                        from anywhere in the world.
                    </p>
                    <button onClick={() => navigate("/login")} className="feature-btn">
                        Learn More
                    </button>
                </div>

                <div className="feature-box">
                    <h2>Global Investments & FX Opportunities</h2>
                    <p>
                        Expand your portfolio with international investment instruments and
                        foreign exchange options. Diversify across stable markets, hedge
                        against currency shifts, and grow your wealth with guided offshore
                        strategies.
                    </p>
                    <button onClick={() => navigate("/login")} className="feature-btn">
                        Explore Options
                    </button>
                </div>
            </section>

            <Explore />

            {/* main page content */}
            <div className="heading-cover-bg">

                <div className="last-section extra">
                    {/* Box 1: Text */}
                    <div className="box">
                        <h2 className="box-title">A Bank That  Actually Cares</h2>
                        <div className="box-text">
                            Every day, there are new challenges for your business.
                            When every decision matters, do you have the right financial partner to help you get it right?
                        </div>
                        <div className="box-text">
                            When you work with the professional business bankers,
                            you’re working with knowledgeable local advisors who take the time to truly understand your business.
                            We’ll work with you so that you can take advantage of opportunities when they come your way.
                            We’ll help you see all your options and work with you to find the right one, so you can confidently move forward to take your business to the next level.
                        </div>
                    </div>

                    {/* Box 2: Image */}
                    <div className="box">
                        <img
                            src={homeBg}
                            alt="Couples"
                            ref={boxImageRef}
                            className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
                        />
                    </div>

                    {/* Box 3: Icon, Heading, and Text */}
                    <div className="box">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLightbulb} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    DEFINE YOUR VISION
                                </h3>
                                <div className="box-text">
                                    Set a clear direction for where your business is headed today, tomorrow, and beyond.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box5Ref}
                            className={`icon-title-text-container animate__animated ${box5InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faUsersGear} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    BUILT AROUND YOUR NEEDS
                                </h3>
                                <div className="box-text">
                                    Every solution is crafted to fit your goals, with flexibility to grow as you do.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faPeopleCarryBox} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    PARTNER IN SUCCESS
                                </h3>
                                <div className="box-text">
                                    Collaborate with us to make smart decisions and move forward with confidence.
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => navigate("/login")}
                            className="hero-btn">
                            Get Started
                        </button>
                    </div>

                </div>

                {/* three column content is next */}
                <h2 className="text-heading center">
                    Exchange Money Internationally in minutes
                </h2>
                <div className="three-box-container">
                    <div
                        ref={box1Ref}
                        className={`box box-cover animate__animated ${box1InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faGlobe} className="box-icon" />
                        <h3 className="box-title center">
                            Global Banking
                        </h3>
                        <div className="box-text center">
                            Open your free digital account and access seamless banking services anywhere in the world.
                        </div>
                    </div>

                    <div
                        ref={box2Ref}
                        className={`box box-cover animate__animated ${box2InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faCommentsDollar} className="box-icon" />
                        <h3 className="box-title center">
                            Fast Money Transfers
                        </h3>
                        <div className="box-text center">
                            Send funds to friends and family across borders instantly, securely, and at the best rates.
                        </div>
                    </div>

                    <div
                        ref={box3Ref}
                        className={`box box-cover animate__animated ${box3InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faChartPie} className="box-icon" />
                        <h3 className="box-title center">
                            Live Market Insights
                        </h3>
                        <div className="box-text center">
                            Track real-time currency trends and make smarter trading and investment decisions.
                        </div>
                    </div>
                </div>



                <div className="showcase-container">
                    <h1 className="showcase-header">Welcome to the Future of Banking 🚀</h1>

                    <div className="showcase-content">
                        <div className="showcase-text">
                            <h2>Introducing the C-Premium Card </h2>
                            <p>
                                Enjoy zero
                                hidden fees, security - driven spending insights, instant cashback, and global
                                access wherever you go. Whether you’re investing, shopping, or exploring
                                the world, C-Premium adapts to your lifestyle and rewards you at every
                                turn.
                            </p>
                            <p>
                                With real - time analytics and personalized recommendations, our card
                                doesn’t just process payments — it empowers smarter financial decisions.
                                Take control of your money with a card that’s built for the future.
                            </p>
                            <button
                                onClick={() => navigate("/login")}
                                className="cta-btn">
                                Get Started
                            </button>
                        </div>

                        <div className="showcase-image">
                            <img src="/card.webp" alt="C-Premium Card" />
                        </div>
                    </div>
                </div>

            </div>

            <Features />

            <h2 className="text-heading center">Earn profit on your savings</h2>
            <SavingsShowcase />


        </>
    );
};

export default HomePage;
